// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentText a{color:#0099e5}.contentText a:hover{color:#0190d7}", "",{"version":3,"sources":["webpack://components/ContentText/index.scss"],"names":[],"mappings":"AAAA,eACE,aAAA,CAGF,qBACE,aAAA","sourcesContent":[".contentText a {\n  color: #0099e5;\n}\n\n.contentText a:hover {\n  color: #0190d7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
